import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  adminUpdateProviderSalesforceId,
  AdminUpdateProviderSalesforceIdInput,
  getProviderDetails,
  patchProviderDetails,
  PatchProviderDetailsInput,
} from '@uplift/api';

import { providerQueryKeys } from './providerQueryKeys';
import { BaseQueryOpts } from '../baseTypes';


export const useProviderDetailsQuery = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: providerQueryKeys.details(providerId),
    queryFn: async () => {
      const details = await getProviderDetails(providerId);

      return details.data;
    },
    ...opts,
  });
};


export const usePatchProviderDetailsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async({ userId, details }: { userId: string; details: PatchProviderDetailsInput }) => {
      await patchProviderDetails(userId, details);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: providerQueryKeys.details(variables.userId)
      });
    },
  });
};


export const useAdminUpdateProviderSalesforceIdMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: AdminUpdateProviderSalesforceIdInput) => adminUpdateProviderSalesforceId(input),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: providerQueryKeys.details(variables.providerId)
      });
    },
  });
};
